// Copyright (c) Microsoft Corporation.
// Licensed under the MIT license.

import React from 'react';
import styles from './loader.module.scss';

interface LoaderProps {
  size?: 'small' | 'medium' | 'large';
  message?: string;
}

const Loader: React.FC<LoaderProps> = ({ size = 'medium', message }) => {
  return (
    <div className={styles.loaderContainer}>
      <div className={`${styles.spinner} ${styles[size]}`}>
        <div className={styles.spinnerRing}></div>
        <div className={styles.spinnerRing}></div>
        <div className={styles.spinnerRing}></div>
      </div>
      {message && <div className={styles.loaderMessage}>{message}</div>}
    </div>
  );
};

export default Loader;
